import { ImageElement, SelectionInfo } from 'dragonmouse-shared/devigner';
import { Frame } from 'dragonmouse-shared/interfaces';
import eventManager from 'events/EventManager';
import Field from '../Field';
import * as S from './styles';

interface ImageEditControlProps {
	frame: Frame;
	selectionInfo: SelectionInfo;
}

const ImageEditControl = ({ frame, selectionInfo }: ImageEditControlProps) => {
	//------------------------------------------------------------------------------------------------
	// HANDLERS
	//------------------------------------------------------------------------------------------------

	// The modal lives in Prototype, not here. If we hosted it in this component, the
	// modal would unmount whenever selection state changes (or the side panel hides)
	const onOpen = () => {
		const elementId = selectionInfo.dataset?.mcElementId ?? selectionInfo.element.id;
		const imageElement: ImageElement = {
			elementId,
			imageUrl: selectionInfo.imageUrl ?? '',
			altTag: selectionInfo.imageAlt ?? '',
		};
		eventManager.emit('open-image-replace-modal', { frameId: frame.id, imageElement });
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------

	return (
		<Field label="Image">
			<S.PillButton onClick={onOpen}>Replace image</S.PillButton>
		</Field>
	);
};

export default ImageEditControl;
